import { render, staticRenderFns } from "./OtherReminderTypes.vue?vue&type=template&id=78456628"
import script from "./OtherReminderTypes.vue?vue&type=script&lang=js"
export * from "./OtherReminderTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports